import I18n from 'I18n';
import { normalizeTypeId, COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CATCHUP_CARDS } from '../../constants/gates';
import { CRM_CATCH_UP_FULL_ACCESS } from '../../constants/scopes';
function createCardNode({
  cardId,
  cardTitle,
  cardType,
  widthInGrid = 12
}) {
  return {
    type: 'CARD',
    layout: {
      type: 'CARD',
      widthInGrid
    },
    definition: {
      cardId,
      cardTitle,
      cardType
    },
    configuration: {}
  };
}
function createContainerNode({
  id,
  label,
  contents,
  layout = {
    type: 'GRID',
    collapsible: true
  },
  containerFeatures = []
}) {
  return {
    type: 'CONTAINER',
    id,
    label,
    layout,
    contents,
    containerFeatures
  };
}
function getOverviewSection() {
  return createContainerNode({
    id: 'HARDCODED_OVERVIEW_SECTION',
    label: I18n.text('catchUpTab.sections.overview'),
    contents: [createCardNode({
      cardId: 'company-description-card',
      cardTitle: '',
      cardType: 'COMPANY_DESCRIPTION'
    }), createCardNode({
      cardId: 'recent-interactions-card',
      cardTitle: I18n.text('catchUpTab.cards.recentInteractions'),
      cardType: 'RECENT_INTERACTIONS'
    })],
    containerFeatures: ['CATCH_UP_OVERVIEW_SECTION']
  });
}
function getHealthSection() {
  return createContainerNode({
    id: 'HARDCODED_HEALTH_SECTION',
    label: I18n.text('catchUpTab.sections.health'),
    contents: [createCardNode({
      cardId: 'sentiment-card',
      cardTitle: I18n.text('catchUpTab.cards.sentiment'),
      cardType: 'SENTIMENT'
    }), createCardNode({
      cardId: 'challenges-pain-points-card',
      cardTitle: I18n.text('catchUpTab.cards.challenges'),
      cardType: 'CHALLENGES_PAIN_POINTS'
    }), createCardNode({
      cardId: 'customer-tidbits-card',
      cardTitle: I18n.text('catchUpTab.cards.positiveFeedback'),
      cardType: 'CUSTOMER_TIDBITS'
    })],
    containerFeatures: ['CATCH_UP_HEALTH_SECTION']
  });
}
function getDataQualitySection() {
  return createContainerNode({
    id: 'HARDCODED_DATA_QUALITY_M2_SECTION',
    label: I18n.text('catchUpTab.sections.dataQuality'),
    contents: [createCardNode({
      cardId: 'missing-properties-card',
      cardTitle: I18n.text('catchUpTab.cards.missingProperties'),
      cardType: 'MISSING_PROPERTIES'
    })],
    containerFeatures: ['CATCH_UP_DATA_QUALITY_SECTION']
  });
}
function insertCatchUpTab({
  locationConfig
}) {
  const sections = [getOverviewSection(), getHealthSection(), getDataQualitySection()];
  return Object.assign({}, locationConfig, {
    container: Object.assign({}, locationConfig.container, {
      contents: [createContainerNode({
        id: 'HARDCODED_CATCH_UP_TAB',
        label: I18n.text('catchUpTab.label'),
        layout: {
          type: 'LIST'
        },
        contents: sections
      }), ...locationConfig.container.contents]
    })
  });
}
export function maybeInsertCatchUpTab({
  locationConfig,
  gates,
  scopes,
  objectTypeId
}) {
  const isCompanyRecord = normalizeTypeId(objectTypeId) === COMPANY_TYPE_ID;
  const isUngatedForCatchUpTab = gates.includes(CATCHUP_CARDS);
  const isScopedForFullAccess = scopes.includes(CRM_CATCH_UP_FULL_ACCESS);
  if (!isCompanyRecord || !isUngatedForCatchUpTab || !isScopedForFullAccess) {
    return locationConfig;
  }
  return insertCatchUpTab({
    locationConfig
  });
}